/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { connect }          from 'react-redux';
import { StyledNavigationList } from '../../components/atoms/StyledNavigationList';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const mapStateToProps = (state) => ({
    isNavigationOpen: state.isNavigationOpen
});

const mapDispatchToProps = (dispatch) => ({});

export const Navigation = connect(mapStateToProps, mapDispatchToProps)(StyledNavigationList);



// WEBPACK FOOTER //
// ./src/containers/Navigation/index.js